import { useParams, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";

import AccountServicesList from "../../components/AccountServicesList";
import Layout from "../../components/Layout";
import IntegrationDetails from "../../components/IntegrationDetails"

import { getRevenueTargetingModels } from "../../services/RevenueTargetingModels";

import AuthContext from "../../context/AuthContext";
import SnackbarContext from "../../context/SnackbarContext";

import { getVesselConnections } from "../../services/Vessel";

export default function IntegrationManagement() {
  const auth = useContext(AuthContext);
	const snackbar = useContext(SnackbarContext);

  const { id, service, integration } = useParams();
  const navigate = useNavigate();

  const [refreshValue, setRefreshValue] = useState(0);
  const [connection, setConnection] = useState({});
  const [revenueTargetingModels, setRevenueTargetingModels] = useState([]);
  const [selectedRevenueTargetingModel, setSelectedRevenueTargetingModel] =
    useState({});
  const [selectedRevenueTargetingModelID, setSelectedRevenueTargetingModelID] =
    useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const getConnection = () => {
    getVesselConnections(auth.token, auth.userAccountID).then((response) => {
      let navigateBool = true;
      if (response.ok) {
        response.json().then(resp => {
          if (resp.connections.length === 0) {
            setConnection({});
          } else {
            resp.connections.forEach(connection => {
              if (connection.integration_id === integration) {
                setConnection(connection);
                navigateBool = false;
              }
            })
          }
        }).finally(() => {
          if (navigateBool) {navigate(`/account`)}
        });
      } else {
        snackbar.createError("Error retrieving connections.");
      }
    }).catch((error) => {
      snackbar.createError("Error retrieving connections.");
    });
  }

  useEffect(() => {
    getConnection()
  }, [refreshValue]);

  const getModels = () => {
    setIsLoading(true);
    setRevenueTargetingModels([]);
    setSelectedRevenueTargetingModel({});
    setSelectedRevenueTargetingModelID(0);

    getRevenueTargetingModels(auth.token)
      .then((response) => {
        response.revenue_targeting_models =
          response.revenue_targeting_models.filter(
            (rtm) => rtm.account === auth.userAccountID
          );

        response.revenue_targeting_models.sort((a, b) => {
          if (Number(a.active) - Number(b.active) === 0) {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else {
            return -(Number(a.active) - Number(b.active));
          }
        });

        setRevenueTargetingModels(response.revenue_targeting_models);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getModels();
  }, []);


  useEffect(() => {
    if (id) {
      let found = false;
      const revenueTargetingModel = revenueTargetingModels.find(
        (revenueTargetingModel) => revenueTargetingModel.id === Number(id)
      );
      if (revenueTargetingModel) {
        setSelectedRevenueTargetingModel(revenueTargetingModel);
        setSelectedRevenueTargetingModelID(Number(id));
        found = true;
      }
      if (!found) {
        setSelectedRevenueTargetingModel([0] || {});
        setSelectedRevenueTargetingModelID(
          revenueTargetingModels[0] ? revenueTargetingModels[0].id : 0
        );
      }
    }
  }, [id]);

  useEffect(() => {
    if (service !== "integrations") {
      navigate("/")
    }
  })

  return (
    <Layout
      sidebar={
        <AccountServicesList
          selectedService={service}
          revenueTargetingModels={revenueTargetingModels}
          selectedRevenueTargetingModelID={selectedRevenueTargetingModelID}
          loading={isLoading}
          getModels={getModels}
        />
      }
      title={
        service ? service.charAt(0).toUpperCase() + service.slice(1) : ""
      }
      modelID={
        selectedRevenueTargetingModel ? selectedRevenueTargetingModel.id : 0
      }
      getModels={getModels}
      main={
        <>
          <IntegrationDetails revenueTargetingModels={revenueTargetingModels} connection={connection} getConnection={getConnection}/>
        </>
      }
    />
  );
}